<template>
    <div class="card p-4">
        <h4 class="bg-success p-4 rounded-1 text-white fw-bold text-uppercase">Unread Messages</h4>
        <div class="card p-4 mt-4">
            <div class="card-body mt-4 col-md-12" v-if="getMessageOptions.length > 0">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th v-for="(header, index) in headers" :key="index">
                            {{ header.text }}
                        </th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="(item, index) in paginatedItems" :key="index">
                        <td>{{ item.name }}</td>
                        <td>{{ item.email }}</td>
                        <td>{{ item.message }}</td>
                        <td>{{ item.mobile }}</td>
                    </tr>
                    </tbody>
                </table>

                <div class="d-flex justify-content-between mt-3">
                    <b-button class="btn btn-outline-dark" :disabled="currentPage === 1" @click="currentPage--">
                        Previous
                    </b-button>

                    <span>Page {{ currentPage }} of {{ totalPages }}</span>

                    <b-button class="btn btn-outline-dark" :disabled="currentPage === totalPages" @click="currentPage++">
                        Next
                    </b-button>
                </div>
            </div>
            <div class="border text-center" v-else>
                Data Not Found !!
            </div>
        </div>
    </div>
</template>

<script>
    import apiRepository from "@/services/ApiRepository";
    import {toast} from "vue3-toastify";

    export default {
        name: "AllMessage",
        data() {
            return {
                headers: [
                    {text: 'Name', value: 'name'},
                    {text: 'Email', value: 'email'},
                    {text: 'Message', value: 'message'},
                    {text: 'Phone', value: 'mobile'}
                ],
                getMessageOptions: [],
                currentPage: 1,
                perPage: 5,

            }
        },
        created() {
            this.allMessageData();
        },
        computed: {
            paginatedItems() {
                const start = (this.currentPage - 1) * this.perPage;
                const end = start + this.perPage;
                return this.getMessageOptions.slice(start, end);
            },

            totalPages() {
                return Math.ceil(this.getMessageOptions.length / this.perPage);
            }
        },
        methods: {
            allMessageData() {
                try {
                    apiRepository.getTotalMessage().then((response) => {
                        if (response) {
                            this.getMessageOptions = response.data
                        } else {
                            toast.error('No messages available!')
                        }
                    })
                } catch (error) {
                    toast.error('Fetching Data Invalid!', error);
                }
            },

        }
    }
</script>

<style scoped>
    .table th,
    .table td {
        padding: 0.75rem;
        vertical-align: top;
        border-top: 1px solid #dee2e6;
        text-align: left !important;
    }
</style>
